module.exports = __webpack_public_path__ + "static/media/regen.c6ddfe3c.mp3";